import type { NextRouter } from 'next/router';
import type { Route } from 'nextjs-routes';

/** Shallow-replaces the URL's query params. An `undefined` value removes the param; a no-op if nothing changed. */
export const replaceRouterQueryParams = (
  router: NextRouter,
  pathname: Route['pathname'],
  updates: Record<string, string | undefined>,
) => {
  const query = { ...router.query };
  let hasChanges = false;

  for (const [key, value] of Object.entries(updates)) {
    if (value !== undefined) {
      if (query[key] !== value) {
        query[key] = value;
        hasChanges = true;
      }
    } else if (query[key] !== undefined) {
      delete query[key];
      hasChanges = true;
    }
  }

  if (hasChanges) {
    router.replace({ pathname, query }, undefined, { shallow: true });
  }
};
